import { FC } from "react"

interface SlowModeControlProps {
  currentSlowMode: number
  onSlowModeChange: (seconds: number) => void
}

const SLOW_MODE_OPTIONS = [0, 3, 5, 10, 30, 60, 120, 300, 600, 1800]

export const SlowModeControl: FC<SlowModeControlProps> = ({ currentSlowMode, onSlowModeChange }) => {
  const formatLabel = (seconds: number): string => {
    if (seconds === 0) return "Off"
    if (seconds < 60) return `${seconds}s`
    return `${seconds / 60}m`
  }

  return (
    <div className="mb-3 flex items-center gap-3 px-3 py-2 bg-gray-50 dark:bg-[rgba(255,255,255,0.03)] border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.08)] rounded-lg">
      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Slow Mode:</span>
      <div className="flex items-center gap-1.5 flex-wrap">
        {SLOW_MODE_OPTIONS.map((seconds) => (
          <button
            key={seconds}
            onClick={() => onSlowModeChange(seconds)}
            className={`px-2.5 py-1 text-xs rounded-md font-medium transition-all ${
              currentSlowMode === seconds
                ? "bg-violet-600 text-white shadow-sm"
                : "bg-white dark:bg-[rgba(255,255,255,0.06)] text-gray-600 dark:text-gray-400 border border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)] hover:border-violet-400 hover:text-violet-600 dark:hover:text-violet-400"
            }`}
          >
            {formatLabel(seconds)}
          </button>
        ))}
      </div>
    </div>
  )
}
